import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function MyReportAttendanceRejectDialog({
  open,
  handleClose,
  handleDone,
  loading = false
}) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    handleDone(reason.trim());
    setReason('');
  };

  const handleCancel = () => {
    setReason('');
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="reject-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="reject-dialog-title">{t('myReports_ReasonOfReject')}</DialogTitle>

      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: 8 }}>
          <textarea
            id="reject-reason"
            style={{
              width: '100%',
              height: '180px',
              resize: 'vertical',
              borderRadius: 10,
              border: '1.5px solid #bdbdbd',
              backgroundColor: '#fafafa',
              padding: '14px 16px',
              fontSize: 15,
              lineHeight: 1.5,
              fontFamily: 'inherit',
              outline: 'none',
              overflowY: 'auto',
              transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
            }}
            onFocus={e => {
              e.target.style.borderColor = '#9b51e0';
              e.target.style.boxShadow = '0 0 0 3px rgba(155,81,224,0.15)';
            }}
            onBlur={e => {
              e.target.style.borderColor = '#bdbdbd';
              e.target.style.boxShadow = 'none';
            }}
            placeholder={t('myReports_rejectReasonPlaceholder')}
            value={reason}
            onChange={e => setReason(e.target.value)}
            disabled={loading}
          />
        </div>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
        <Button
          onClick={handleCancel}
          color="primary"
          variant="contained"
          disabled={loading}
          style={{ minWidth: 120 }}
        >
          {t('myReports_cancel')}
        </Button>

        <Button
          onClick={handleConfirm}
          color="secondary"
          variant="contained"
          disabled={loading || !reason.trim()}
          style={{ minWidth: 120 }}
        >
          {t('myReports_confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
